import MediumEditor from "medium-editor";
import bus from "../util/bus";
import AppState from "../util/AppState";
import BlockSettings from "../blocks/_BlockSettings";

export const BlocksMixin = {
  props: ["block", "order"],
  data() {
    return {
      reqLoaded: 0,
      editor1: null,
      AppState
    };
  },
  components: {
    "block-settings": BlockSettings
  },
  created() {
    // Cleanup editor markup from html
    bus.$on("prePublish", () => {
      if (this.editor1) {
        this.editor1.unsubscribe("editableKeydownEnter");
        this.editor1.destroy();
      }
    });
    // re-init editors
    bus.$on("postPublish", () => {
      if (!this.block.type === "nav") {
        this.createEditors();
      }
    });
    // Load Scripts when required .js are loaded
    bus.$on("previewInit", () => {
      this.blockInit();
    });
    // Load Scripts when required .js are loaded
    bus.$on(`requiredLoaded_${this.block.template}`, () => {
      this.addCustomScript();
    });
  },
  mounted() {
    const already = AppState.currentPage.blocks.filter(b => b.type === "nav")
      .length;

    // ADD BLOCK STYLES
    this.doc = this.$root.$el.ownerDocument;
    if (!already) {
      this.addStyle(
        `${AppState.baseURL}/static/templates/theme1/${this.block.template}.css`
      );
      if (AppState.previewReady) {
        this.blockInit();
      }
    }

    this.$nextTick(() => {
      this.createEditors();
    });
  },
  methods: {
    clickDisable() {
      // OPEN POPUP EDIT
    },
    createEditors() {
      if (this.editables && this.editables.length > 0) {
        const mediumOptions = {
          contentWindow: this.$root.$el.ownerDocument.defaultView,
          ownerDocument: this.$root.$el.ownerDocument,
          extensions: {},
          toolbar: {
            buttons: ["bold", "italic", "underline", "anchor"]
          },
          autoLink: true
        };
        /* eslint-disable no-new */
        this.editor1 = new MediumEditor(this.editables, mediumOptions);
        this.editor1.subscribe("editableKeydownEnter", event => {
          if (!event.shiftKey && (event.which === 13 || event.keyCode === 13)) {
            event.preventDefault();
            AppState.error.text = "Use Shift + Enter to add line break.";
            AppState.error.show = true;
          }
          return false;
        });
      }
    },
    updateBlockText(ev, opt1, opt2) {
      this.block.options[opt1][opt2] = ev.target.innerHTML;
    },
    deleteBlock() {
      if (this.editor1) {
        this.editor1.unsubscribe("editableKeydownEnter");
        this.editor1.destroy();
      }
      this.$emit("deleteBlock");
    },
    moveBlockDown() {
      this.$emit("moveBlock", { dir: 1, el: this.$el });
      if (this.afterMove) {
        this.$nextTick(() => {
          this.afterMove();
        });
      }
    },
    moveBlockUp() {
      this.$emit("moveBlock", { dir: -1, el: this.$el });
      if (this.afterMove) {
        this.$nextTick(() => {
          this.afterMove();
        });
      }
    },
    blockInit() {
      // LOAD BLOCK SCRIPT
      if (this.block.firebase) {
        this.initFirebase();
      }
      if (this.block.required.length > 0) {
        this.block.required.forEach(r => {
          if (!AppState.currentPage.loaded.includes(r.title)) {
            AppState.currentPage.loaded.push(r.title);
            if (r.css) {
              this.addStyle(
                `${AppState.baseURL}/static/templates/theme1/js/vendor/${r.css}`
              );
            }
            if (r.js) {
              this.addScriptCb(
                `${AppState.baseURL}/static/templates/theme1/js/vendor/${r.js}`,
                () => {
                  AppState.currentPage.loadedDone.push(r.title);
                  this.reqLoaded += 1;
                  this.checkRequired();
                }
              );
            }
            // Has been loaded. Check if already done and load Custom, otherwise wait for bus emit
          } else if (AppState.currentPage.loadedDone.includes(r.title)) {
            this.addCustomScript();
          }
        });
      } else {
        this.addCustomScript();
      }
    },
    checkRequired() {
      if (this.reqLoaded >= this.block.required.length) {
        bus.$emit(`requiredLoaded_${this.block.template}`);
      }
    },
    addCustomScript() {
      // Also add external .js if any
      if (this.block.hasScript) {
        this.addScriptCb(
          `${AppState.baseURL}/static/templates/theme1/${
            this.block.template
          }.js`,
          () => {
            this.appendCustomScript();
          }
        );
      } else {
        this.appendCustomScript();
      }
    },
    initFirebase() {
      if (AppState.currentPage.blocks.filter(b => b.firebase).length === 1) {
        this.addScriptCb(AppState.firebaseURL, () => {
          this.addScriptCb(AppState.firestoreURL, () => {
            this.addScriptInline(`
              var config = ${AppState.currentProject.firebaseConfig};
              firebase.initializeApp(config);
              var auth = {};
              firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  auth.anonymous = user.isAnonymous;
                  auth.uid = user.uid;
                  auth.user = user;
                } else {
                  auth = {};
                }
              });
              firebase.auth().signInAnonymously().catch(function(error) {
                console.error(error.code, error.message);
              });
              var db = firebase.firestore();
            `);
          });
        });
      }
    },
    addStyle(src) {
      const link = this.doc.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.media = "all";
      link.href = src;
      this.doc.head.appendChild(link);
    },
    addScript(src) {
      // ADD BLOCK SCRIPT (IF ANY)
      const script = this.doc.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      this.doc.body.appendChild(script);
    },
    addScriptInline(txt) {
      // ADD BLOCK SCRIPT (IF ANY)
      const script = this.doc.createElement("script");
      script.type = "text/javascript";
      script.text = txt;
      this.doc.body.appendChild(script);
    },
    addScriptCb(src, callback) {
      const script = this.doc.createElement("script");
      script.type = "text/javascript";
      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = () => {
          callback();
        };
      }
      script.src = src;
      this.doc.body.appendChild(script);
    }
  }
};

export const otherMixin = {};



// WEBPACK FOOTER //
// ./src/util/mixins.js